import React from 'react';
import PropTypes from 'prop-types';
import { LocalizationContext } from '../../../hoc/Localization';
import ClaimOwnership from '../ClaimOwnership';
import Rating from '../../Rating';
import Router from '../../../routes';
import styles from './styles.less';

const Header = ({ school, canEdit }) => {
  const { title, logo, rating, location, phone, websiteUrl } = school;
  const { t, locale } = React.useContext(LocalizationContext);

  const infos = [
    {
      title: t('details.address'),
      key: 'address',
      value: (
        <>
          {!!location &&
            `${location.city}, ${location.street} ${location.house_number || null}, ${
              location.zip_code
            }`}
        </>
      ),
    },
    {
      title: t('form.phone'),
      key: 'phone',
      value: <>{phone}</>,
    },
    {
      title: t('school.header.details.website'),
      key: 'website',
      value: (
        <>
          <a href={websiteUrl} target="_blank" rel="noopener noreferrer">
            {websiteUrl}
          </a>
        </>
      ),
    },
  ];

  const urlFront = logo ? logo.substring(0, logo.lastIndexOf('.')) : '';
  const ext = logo ? logo.slice(logo.lastIndexOf('.'), logo.length) : '';
  const smallUrl = urlFront ? urlFront.concat('-small').concat(ext) : '';

  return (
    <div id="schoolHeader" className={styles.row}>
      <div className={styles.container}>
        <div className={styles.logoContainer}>
          <img
            className={styles.logo}
            src={!logo.includes('static') ? smallUrl : logo}
            alt={title}
          />
        </div>
        <div className={styles.titleContainer}>
          <div className={styles.title}>
            <div className={styles.titleInner}>
              <div className={styles.schoolEmailAndTitle}>
                <h1>{title}</h1>
              </div>
              {!canEdit && (
                <div
                  onClick={() =>
                    Router.pushRoute('schoolShow', {
                      school: school.link,
                      id: school.shortId,
                      locale,
                      claim: 'claim',
                    })}
                >
                  <ClaimOwnership school={school} />
                </div>
              )}
            </div>
            <div className={styles.rateContainer}>
              <Rating rating={rating} />
            </div>
          </div>

          <div className={styles.info}>
            {infos.map(info => (
              <div className={[styles.infoItem, 'description'].join(' ')} key={info.key}>
                <span>{info.title}</span>
                <span>{info.value}</span>
              </div>
            ))}
            <div className={styles.infoItem} />
          </div>
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  school: PropTypes.object.isRequired,
  canEdit: PropTypes.bool,
};

Header.defaultProps = {
  canEdit: false,
};

export default Header;
